import { render, staticRenderFns } from "./TableCellFilesFileSize.vue?vue&type=template&id=7dc068e4&scoped=true"
import script from "./TableCellFilesFileSize.vue?vue&type=script&lang=js"
export * from "./TableCellFilesFileSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc068e4",
  null
  
)

export default component.exports